import { useLocation, useNavigate, useParams } from 'react-router-dom';

import React, { useEffect, useState } from 'react';
import Animate from '../../about/Animate';
import { checkNafathLogin, checkoutActivation, checkoutConfirm, getOrderById, nafathLogin, setContractType } from '../../../services/sim.service';
import Header from '../../../components/header/header';
import Footer from '../../../components/footer/footer';
import SideInfo from '../components/sideInfo';
import { Button, Card, Modal } from 'react-bootstrap';
import { ObjectArray } from '../Page';
import { useTranslation } from 'react-i18next';
import { ShimmerTitle } from "react-shimmer-effects";
import { Info } from '../../../components/compare/components/OrderItem';
import { getPlanbyId } from '../../../services/stepper.service';
import { getProvider } from '../../../services/providers.service';
import { ButtonSquare } from '../../../components/design/buttons/Button';
import { BiQrScan } from 'react-icons/bi';
import { BiChevronRight } from 'react-icons/bi';
import { TbDeviceSim } from 'react-icons/tb';
import { BiLoaderAlt } from 'react-icons/bi';
import { BiCheck } from 'react-icons/bi';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
// import s'./Store.css';
import { HiOutlineThumbUp } from 'react-icons/hi';
import { IoIosArrowForward, IoIosClipboard, IoIosDocument } from 'react-icons/io';
import { IoCopy, IoCopyOutline } from 'react-icons/io5';
import { Carousel } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from "react-toastify";
import { QRCodeCanvas } from 'qrcode.react';
import './Order.css';

const orderFetchCooldownMs = 2000;
const orderFetchCache = new Map<string, number>();

const PageLocalSimOrder = () => {
    const hasProcessedRef = React.useRef(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const orderFetchKeyRef = React.useRef<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [order, setOrder] = useState<any>(null);
    const [provider, SetProvider] = useState<any>(null);
    const [verificationProccessError, setVerificationProccessError] = React.useState<string | null>(null);
    const [isProcessStarted, setIsProcessStarted] = useState<boolean>(false);
    const { t, i18n } = useTranslation();
    const [transId, setTransId] = useState<string | null>(null);
    const [randomNumber, setRandomNumber] = useState<string | null>(null);
    const [isRandomNumberDialogOpen, setIsRandomNumberDialogOpen] = useState<boolean>(false);
    const [countdown, setCountdown] = useState<number>(180); // 3 minutes in seconds
    const nafathCheckIntervalRef = React.useRef<NodeJS.Timeout | null>(null);
    const [verificationProccessStated, setVerificationProccessStates] = React.useState(
        {
            "checkoutConfirm": false,
            "GetOrderById": false,
            "nafathLogin": false,
            "checkNafathLogin": false,
            "CheckoutActivation": false
        }
    );

    // Add new state for ICCID input
    const [iccid, setIccid] = useState<string>('');
    const [isActivating, setIsActivating] = useState<boolean>(false);
    const [isAutoActivating, setIsAutoActivating] = useState<boolean>(false);
    const [showServiceFeesInfo, setShowServiceFeesInfo] = useState(false);
    const [isJustActivated, setIsJustActivated] = useState<boolean>(false);

    // Helper: plan id used for activation/nafath calls (resellerPlanId for this backend)
    const getActivationPlanId = () => order?.plan?.resellerPlanId || +(searchParams.get('planId') || 0) || 0;

    // Add function to handle manual activation
    const handleManualActivation = async () => {
        if (!iccid) {
            setVerificationProccessError(t('activation.Please enter ICCID'));
            return;
        }

        try {
            setVerificationProccessError(null);
            const response_checkoutActivation = await checkoutActivation(
                {
                    providerOrderId: searchParams.get('providerOrderId'),
                    tygoOrderId: searchParams.get('tygoOrderId'),
                    iccid: iccid,
                    iam_token: transId || '',
                    fingerindex: 0,
                    fingerImage: "",
                    tcn: "",
                    faceImage: "",
                    plan_id: getActivationPlanId(),
                },
                +(searchParams.get('providerId') || '0'),
                i18n.language
            );

            if (response_checkoutActivation) {
                if (response_checkoutActivation.isSucceeded === false) {
                    // Show both the translated message and the API error message
                    const translatedError = t(`activation.${response_checkoutActivation.errorMessage}`, { defaultValue: response_checkoutActivation.errorMessage });
                    const errorMessage = `${t('activation.Activation failed. Please try again.')} (${translatedError})`;
                    setVerificationProccessError(errorMessage);
                } else {
                    setVerificationProccessStates({
                        ...verificationProccessStated,
                        CheckoutActivation: true
                    });
                    setIsJustActivated(true);
                }
            }
        } catch (error: any) {
            console.error('Activation failed:', error.response?.data?.errorMessage);
            const errorMsg = error.response?.data?.errorMessage || 'Unknown error';
            const translatedError = t(`activation.${errorMsg}`, { defaultValue: errorMsg });
            const errorMessage = `${translatedError}`;
            setVerificationProccessError(errorMessage);
        } finally {
            setIsActivating(false);
        }
    };

    // Function to fetch order details
    const fetchOrderDetails = async (options?: { force?: boolean }) => {
        try {
            const providerId = searchParams.get('providerId');
            const tygoOrderId = searchParams.get('tygoOrderId');
            const providerOrderId = searchParams.get('providerOrderId');

            if (!providerId || !tygoOrderId || !providerOrderId) {
                setVerificationProccessError('Missing required parameters');
                return;
            }

            // De-dup identical fetches (React strict-mode double-mount / language re-runs)
            const fetchKey = `${providerId}|${tygoOrderId}|${providerOrderId}|${i18n.language}`;
            if (!options?.force && orderFetchKeyRef.current === fetchKey) {
                return;
            }
            orderFetchKeyRef.current = fetchKey;
            const now = Date.now();
            const lastFetch = orderFetchCache.get(fetchKey);
            if (!options?.force && lastFetch && now - lastFetch < orderFetchCooldownMs) {
                return;
            }
            orderFetchCache.set(fetchKey, now);

            const order = await getOrderById(+providerId, tygoOrderId, providerOrderId, i18n.language);
            if (order) {
                // refreshed from the order itself, so activation keeps sending the
                // right contract type even when the flow's value is gone or stale
                setContractType(order?.plan?.contractTypeId);
                // Resolve provider from the order's own providerId, matching it out of the returned list
                const providerIdFromOrder = Number(order?.plan?.providerId);
                const providerIdFromQuery = Number(providerId);
                const providerIdForFetch = Number.isFinite(providerIdFromOrder) && providerIdFromOrder > 0
                    ? providerIdFromOrder
                    : providerIdFromQuery;
                if (Number.isFinite(providerIdForFetch) && providerIdForFetch > 0) {
                    const provider = await getProvider(providerIdForFetch, i18n.language);
                    const providerList = Array.isArray(provider) ? provider : [provider];
                    const matchedProvider = providerList.find((p: any) => String(p?.id) === String(providerIdForFetch)) || providerList[0] || null;
                    SetProvider(matchedProvider);
                } else {
                    SetProvider(null);
                }

                setOrder(order);
                setIsLoading(false);

                // If the order is already activated, skip straight to the completed state
                const isActivated = !!(order.esim && (order.esim.qrCode_text || order.esim.smdp || order.esim.activation_code));
                if (isActivated) {
                    setIsProcessStarted(true);
                    setVerificationProccessStates({
                        checkoutConfirm: true,
                        GetOrderById: true,
                        nafathLogin: true,
                        checkNafathLogin: true,
                        CheckoutActivation: true
                    });
                }
            }
        } catch (error: any) {
            setVerificationProccessError(error.message);
            setIsLoading(false);
        }
    };

    // Modified verification process to only handle verification steps
    const verificationProcess = async () => {
        try {
            setVerificationProccessStates(prevState => ({
                ...prevState,
                checkoutConfirm: true,
                GetOrderById: true
            }));

            const providerId = searchParams.get('providerId');
            const tygoOrderId = searchParams.get('tygoOrderId');
            const providerOrderId = searchParams.get('providerOrderId');
            const planId = getActivationPlanId();

            if (!providerId || !tygoOrderId || !providerOrderId) {
                setVerificationProccessError('Missing required parameters');
                return;
            }

            const response = await nafathLogin(
                {
                    nationality_id_number: order.eligibility.nationalityIdNumber,
                    service: order.numberOrderType === 1 ? "transfer_ownership_global" : "new_mobile",
                    plan_id: planId
                },
                +providerId,
                i18n.language
            );

            if (response && response.isSucceeded) {
                setVerificationProccessStates(prevState => ({
                    ...prevState,
                    nafathLogin: true
                }));
                setRandomNumber(response.returnData.random);
                setIsRandomNumberDialogOpen(true);
                setTransId(response.returnData.transId);

                // Clear any existing interval before starting a new one
                if (nafathCheckIntervalRef.current) {
                    clearInterval(nafathCheckIntervalRef.current);
                }

                nafathCheckIntervalRef.current = setInterval(async () => {
                    const response_checkNafathLogin = await checkNafathLogin(
                        {
                            code: response.returnData.transId,
                            plan_id: planId
                        },
                        +providerId,
                        i18n.language
                    );

                    if (response_checkNafathLogin.isSucceeded != true) {
                        setVerificationProccessStates({
                            ...verificationProccessStated,
                            checkNafathLogin: false
                        });
                    } else {
                        setVerificationProccessStates({
                            ...verificationProccessStated,
                            checkNafathLogin: true
                        });

                        setIsRandomNumberDialogOpen(false);
                        if (nafathCheckIntervalRef.current) {
                            clearInterval(nafathCheckIntervalRef.current);
                            nafathCheckIntervalRef.current = null;
                        }

                        if ((order && order.simType === '1' ? 'sim' : 'esim') === 'esim') {
                            setIsAutoActivating(true);
                            try {
                                const response_checkoutActivation = await checkoutActivation(
                                    {
                                        providerOrderId: providerOrderId,
                                        tygoOrderId: tygoOrderId,
                                        iccid: "",
                                        iam_token: response.returnData.transId,
                                        fingerindex: 0,
                                        fingerImage: "",
                                        tcn: "",
                                        faceImage: "",
                                        plan_id: planId,
                                    },
                                    +providerId,
                                    i18n.language
                                );
                                if (response_checkoutActivation) {
                                    setVerificationProccessStates({
                                        ...verificationProccessStated,
                                        CheckoutActivation: true
                                    });
                                    setIsJustActivated(true);
                                    //refetch order details to update state
                                    await fetchOrderDetails({ force: true });
                                }
                            } catch (error: any) {
                                console.error('Auto activation failed:', error);
                                setVerificationProccessError(error.message || 'Auto activation failed');
                            } finally {
                                setIsAutoActivating(false);
                            }
                        }
                    }
                }, 5000);

                // Set timeout to clear interval after 3 minutes
                setTimeout(() => {
                    if (nafathCheckIntervalRef.current) {
                        clearInterval(nafathCheckIntervalRef.current);
                        nafathCheckIntervalRef.current = null;
                    }
                }, 180000);
            }
        } catch (error: any) {
            setVerificationProccessError(error.message);
        }
    };

    // Add cleanup effect
    React.useEffect(() => {
        return () => {
            // Cleanup function to clear interval when component unmounts
            if (nafathCheckIntervalRef.current) {
                clearInterval(nafathCheckIntervalRef.current);
                nafathCheckIntervalRef.current = null;
            }
        };
    }, []);

    // Scroll to top on key state transitions
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [isLoading, isProcessStarted]);

    // Fetch order details on component mount and when language changes
    React.useEffect(() => {
        fetchOrderDetails();
    }, [i18n.language]);

    // Add countdown effect
    React.useEffect(() => {
        if (isRandomNumberDialogOpen && countdown > 0) {
            const timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        return 180; // Reset to 3 minutes
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [isRandomNumberDialogOpen, countdown]);

    // Format time function
    const formatTime = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    const hasEsimData = !!(
        order?.esim &&
        (order.esim.activation_code ||
            order.esim.confirmation_code ||
            order.esim.qrCode_text ||
            order.esim.qrCode_url ||
            order.esim.smdp)
    );

    //show if there is an error message and show the verificationProccessStates
    return (
        <>
            {verificationProccessError && <div className="alert alert-danger">{verificationProccessError}</div>}
            {isJustActivated && (
                <div className="alert alert-success">
                    {t("activation.Your SIM has been successfully activated!")}
                </div>
            )}

            <div className="page-container container" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <Header />
                {
                    order ?
                        <div className="container h-100 mt-4">
                            <div className="row">
                                <div className="col-12 col-lg-8 h-100">
                                    {!isProcessStarted ? (
                                        <div className="col-12 mb-4">
                                            <div className="input_bg p-4 text-center">
                                                <h3 className="mb-4">{t("activation.Start Verification Process")}</h3>
                                                <ButtonSquare
                                                    color="primary"
                                                    isrounded={true}
                                                    inner={t('activation.Start Process')}
                                                    onClick={() => {
                                                        setIsProcessStarted(true);
                                                        verificationProcess();
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {/* All steps are done */}
                                            {verificationProccessStated.checkoutConfirm && verificationProccessStated.GetOrderById && verificationProccessStated.nafathLogin && verificationProccessStated.CheckoutActivation && (
                                                <div className="col-12 mb-4">
                                                    <div className="input_bg_green p-4">
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <span className='icon_det' style={{ color: 'white', fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#3EB6AE', width: '40px', height: '40px', borderRadius: '50%' }}>
                                                                <BiCheck />
                                                            </span>
                                                            <span>{t("activation.Your SIM is now active. You can start using your mobile service.")}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {!verificationProccessStated.CheckoutActivation && (
                                                <>
                                            {/* Processing Step */}
                                            <div className="col-12 mb-4">
                                                <div className={`input_bg p-4 ${verificationProccessStated.checkoutConfirm && verificationProccessStated.GetOrderById ? 'step' : 'active_step'}`} onClick={() => { }} style={{ cursor: "pointer" }}>
                                                    <div className="d-flex align-items-center flex-row gap-2 justify-content-center" style={{ flexDirection: "column" }}>
                                                        <span className='icon_det' style={{ color: 'white', fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#3EB6AE', width: '40px', height: '40px', borderRadius: '50%' }}>
                                                            {verificationProccessStated.checkoutConfirm && verificationProccessStated.GetOrderById ? (
                                                                <BiCheck />
                                                            ) : (
                                                                <div className="d-flex align-items-center justify-content-center w-100 h-100" style={{ gap: "4px" }}>
                                                                    <div className="dot"></div>
                                                                    <div className="dot"></div>
                                                                    <div className="dot"></div>
                                                                </div>
                                                            )}
                                                        </span>
                                                        <span>{t("activation.Step 1")}</span>
                                                    </div>
                                                    <span>{t("activation.Processing")}</span>
                                                </div>
                                            </div>

                                            {/* Delivery Step - Only show for SIM type */}
                                            {(order && order.simType === '1' ? 'sim' : 'esim') === 'sim' && (
                                                <div className="col-12 mb-4">
                                                    <div className={`input_bg p-4 ${verificationProccessStated.checkoutConfirm && verificationProccessStated.GetOrderById && !verificationProccessStated.nafathLogin ? 'active_step' : 'step'}`} onClick={() => { }} style={{ cursor: "pointer" }}>
                                                        <div className="d-flex align-items-center flex-row gap-2 justify-content-center" style={{ flexDirection: "column" }}>
                                                            <span className='icon_det' style={{ color: 'white', fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#3EB6AE', width: '40px', height: '40px', borderRadius: '50%' }}>
                                                                {verificationProccessStated.checkoutConfirm && verificationProccessStated.GetOrderById ? (
                                                                    <BiCheck />
                                                                ) : (
                                                                    <div className="d-flex align-items-center justify-content-center w-100 h-100" style={{ gap: "4px" }}>
                                                                        <div className="dot"></div>
                                                                        <div className="dot"></div>
                                                                        <div className="dot"></div>
                                                                    </div>
                                                                )}
                                                            </span>
                                                            <span>{t("activation.Step 2")}</span>
                                                        </div>
                                                        <span>{t("activation.Delivery")}</span>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Nafaz Step */}
                                            <div className="col-12 mb-4">
                                                <div className={`input_bg2 p-4 ${verificationProccessStated.checkNafathLogin && verificationProccessStated.CheckoutActivation ? 'step' : 'active_step'}`} onClick={() => { }} style={{ cursor: "pointer" }}>
                                                    <div className='d-flex justify-content-between align-items-center w-100'>
                                                        <div className="d-flex align-items-center flex-row gap-2 justify-content-center" style={{ flexDirection: "column" }}>
                                                            <span className='icon_det' style={{ color: 'white', fontSize: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#3EB6AE', width: '40px', height: '40px', borderRadius: '50%' }}>
                                                                {verificationProccessStated.checkNafathLogin && verificationProccessStated.CheckoutActivation ? (
                                                                    <BiCheck />
                                                                ) : isAutoActivating ? (
                                                                    <BiLoaderAlt className="animate-spin" />
                                                                ) : (
                                                                    <div className="d-flex align-items-center justify-content-center w-100 h-100" style={{ gap: "4px" }}>
                                                                        <div className="dot"></div>
                                                                        <div className="dot"></div>
                                                                        <div className="dot"></div>
                                                                    </div>
                                                                )}
                                                            </span>
                                                            <span>{t((order && order.simType === '1' ? 'sim' : 'esim') === 'esim' ? "activation.Step 2" : "activation.Step 3")}</span>
                                                        </div>
                                                        <span>{t("activation.Nafath")}</span>
                                                    </div>
                                                    {(order && order.simType === '1' ? 'sim' : 'esim') === 'sim' && !verificationProccessStated.CheckoutActivation && (
                                                        <div className="mt-3 w-100">
                                                            <input
                                                                type="text"
                                                                className={`form-control w-100 ${verificationProccessError ? 'is-invalid' : ''}`}
                                                                placeholder={t("activation.Enter ICCID") as string}
                                                                value={iccid}
                                                                onChange={(e) => {
                                                                    setIccid(e.target.value);
                                                                    // Clear error when user starts typing
                                                                    if (verificationProccessError) {
                                                                        setVerificationProccessError(null);
                                                                    }
                                                                }}
                                                                disabled={verificationProccessStated.CheckoutActivation || isActivating}
                                                                style={{
                                                                    borderRadius: "16px",
                                                                    border: `1px solid ${verificationProccessError ? '#dc3545' : '#F6F3FC'}`,
                                                                    boxShadow: "0px 4px 40px 0px #0000000A",
                                                                    height: "84px"
                                                                }}
                                                            />
                                                            {verificationProccessError && (
                                                                <div className="invalid-feedback d-block mt-2" style={{ color: '#dc3545' }}>
                                                                    {verificationProccessError}
                                                                </div>
                                                            )}
                                                            <ButtonSquare
                                                                color="primary mt-3"
                                                                isrounded={true}
                                                                inner={isActivating ? t('activation.Activating...') : t('activation.Confirm')}
                                                                onClick={() => {
                                                                    setIsActivating(true);
                                                                    handleManualActivation();
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {hasEsimData && (
                                        <div className="order_tabs my-4">
                                            <h4>{t("store.install_esim")}</h4>
                                            {order ?
                                                <TabsInfo order={order} />
                                                :
                                                <ShimmerTitle line={2} gap={10} variant="primary" />
                                            }
                                        </div>
                                    )}
                                </div>
                                <div className="col-12 col-lg-4">
                                    <SideInfo
                                        background={provider?.imagePathLarge || order?.plan?.imageUrl || ""}
                                        backgroundColor={provider?.primaryColor}
                                        is_bg={true}
                                        elements={[
                                            <div className="plan-item m-0 p-0">
                                                {!isLoading && order?.plan ? (
                                                    <>
                                                        <h3>{order.plan.name}</h3>
                                                        <span className='price_item'>{order.plan.price} {t('global.sar')}</span>
                                                    </>
                                                ) : (
                                                    <ShimmerTitle line={2} gap={10} variant="primary" />
                                                )}
                                                <div className="d-flex gap-2 mt-4">
                                                    {!isLoading && order?.plan ? (
                                                        <Info name={t("details.type")} logo="/media/svgs/clock_.svg" info={t(order.plan.contractTypeId === 1 ? t("details.prepaid") : t("details.postpaid"))} />
                                                    ) : (
                                                        <div className="w-100">
                                                            <ShimmerTitle line={2} gap={10} variant="primary" />
                                                        </div>
                                                    )}
                                                    {!isLoading ? (
                                                        <Info name={t("details.provider")} logo="/media/svgs/rss.svg" info={provider ? provider.name : ""} />
                                                    ) : (
                                                        <div className="w-100">
                                                            <ShimmerTitle line={2} gap={10} variant="primary" />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>,
                                            <></>,
                                            !isLoading && order?.plan ? (
                                                <div className="table_info">
                                                    <div className="d-flex title_item align-items-center gap-2">
                                                        <img src="/media/svgs/list.svg" />
                                                        <h6 className='m-0'>{t('store.order_details')}</h6>
                                                    </div>
                                                    <div className="d-flex justify-content-between table_item">
                                                        <span>{t('store.price')}</span>
                                                        <span>{order?.plan?.price} {t('global.sar')}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between table_item">
                                                        <span>{t('store.quantity')}</span>
                                                        <span>1</span>
                                                    </div>
                                                    {order?.fees ? (
                                                        [...order.fees]
                                                            .filter((f: any) => f.type !== 4)
                                                            .sort((a: any, b: any) => (a.type === 5 ? 1 : 0) - (b.type === 5 ? 1 : 0))
                                                            .map((fee: any, i: number) => (
                                                                <div key={i} className="d-flex justify-content-between table_item">
                                                                    <span className="d-flex align-items-center gap-2">
                                                                        {fee.name}
                                                                        {fee.type === 5 && (
                                                                            <AiOutlineInfoCircle
                                                                                size={18}
                                                                                style={{ cursor: 'pointer', color: '#3EB6AE' }}
                                                                                onClick={() => setShowServiceFeesInfo(true)}
                                                                            />
                                                                        )}
                                                                    </span>
                                                                    <span>{Number(fee.value).toFixed(2)} {t('global.sar')}</span>
                                                                </div>
                                                            ))
                                                    ) : (
                                                        <div className="d-flex justify-content-between table_item">
                                                            <span>{t('store.fees')}</span>
                                                            <span>0 {t('global.sar')}</span>
                                                        </div>
                                                    )}
                                                    <div className="devider"></div>
                                                    <div className="d-flex justify-content-between ">
                                                        <span>{t('store.total')}</span>
                                                        <strong className='c-primary'>
                                                            {order?.fees?.find((f: any) => f.type === 4)
                                                                ? Number(order.fees.find((f: any) => f.type === 4).value).toFixed(2)
                                                                : order?.plan?.price
                                                            } {t('global.sar')}
                                                        </strong>
                                                    </div>
                                                </div>
                                            ) : (
                                                <ShimmerTitle line={2} gap={10} variant="primary" />
                                            )
                                        ]}
                                        noBg={[1]}
                                    />
                                </div>
                            </div>
                        </div> : <div className="container h-100 mt-4">
                            {verificationProccessError ? <div className="alert alert-danger mt-3">{verificationProccessError}</div> :
                                <div className="row">
                                    {/* Left Column - Main Steps */}
                                    <div className="col-12 col-lg-8 h-100">
                                        {/* 3 shimmer cards for the steps */}
                                        {[1, 2, 3].map((step) => (
                                            <div key={`step-${step}`} className="col-12 mb-4">
                                                <div className="input_bg p-4">
                                                    <div className="d-flex align-items-center flex-row gap-2 justify-content-center" style={{ flexDirection: "column" }}>
                                                        {/* Circle shimmer for icon */}
                                                        <div style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            borderRadius: "50%",
                                                            backgroundColor: "#f6f7f8",
                                                            position: "relative",
                                                            overflow: "hidden"
                                                        }}>
                                                            <div className="shimmer-effect" style={{
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                width: "100%",
                                                                height: "100%",
                                                                background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
                                                                animation: "shimmer 1.5s infinite"
                                                            }}></div>
                                                        </div>
                                                        {/* Title shimmer */}
                                                        <div style={{width: "80px"}}>
                                                            <ShimmerTitle line={1} gap={10} variant="primary" />
                                                        </div>
                                                    </div>
                                                    {/* Description shimmer */}
                                                    <div style={{width: "120px"}}>
                                                        <ShimmerTitle line={1} gap={10} variant="primary" />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        {/* 1 shimmer card for the eSIM install section */}
                                        <div className="order_tabs my-4">
                                            <div style={{width: "200px"}}>
                                                <ShimmerTitle line={1} gap={10} variant="primary" />
                                            </div>
                                            <div className="input_bg p-4 mt-3">
                                                <ShimmerTitle line={3} gap={10} variant="primary" />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right Column - Summary/Info */}
                                    <div className="col-12 col-lg-4">
                                        {/* 1 shimmer card for the plan name/price */}
                                        <div className="plan-item m-0 p-0 mb-4">
                                            <ShimmerTitle line={2} gap={10} variant="primary" />
                                        </div>

                                        {/* 2 shimmer cards for info rows (type, provider) */}
                                        <div className="d-flex gap-2 mb-4">
                                            <div className="w-100">
                                                <ShimmerTitle line={2} gap={10} variant="primary" />
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2 mb-4">
                                            <div className="w-100">
                                                <ShimmerTitle line={2} gap={10} variant="primary" />
                                            </div>
                                        </div>

                                        {/* 1 shimmer card for the table */}
                                        <div className="table_info">
                                            <div className="d-flex title_item align-items-center gap-2 mb-3">
                                                <div style={{
                                                    width: "20px",
                                                    height: "20px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f6f7f8",
                                                    position: "relative",
                                                    overflow: "hidden"
                                                }}>
                                                    <div className="shimmer-effect" style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
                                                        animation: "shimmer 1.5s infinite"
                                                    }}></div>
                                                </div>
                                                <div style={{width: "120px"}}>
                                                    <ShimmerTitle line={1} gap={10} variant="primary" />
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between table_item mb-2">
                                                <div style={{width: "60px"}}>
                                                    <ShimmerTitle line={1} gap={10} variant="primary" />
                                                </div>
                                                <div style={{width: "80px"}}>
                                                    <ShimmerTitle line={1} gap={10} variant="primary" />
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between table_item mb-2">
                                                <div style={{width: "80px"}}>
                                                    <ShimmerTitle line={1} gap={10} variant="primary" />
                                                </div>
                                                <div style={{width: "100px"}}>
                                                    <ShimmerTitle line={1} gap={10} variant="primary" />
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between table_item">
                                                <div style={{width: "70px"}}>
                                                    <ShimmerTitle line={1} gap={10} variant="primary" />
                                                </div>
                                                <div style={{width: "90px"}}>
                                                    <ShimmerTitle line={1} gap={10} variant="primary" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                }
            </div>
            <Modal show={isRandomNumberDialogOpen} onHide={() => setIsRandomNumberDialogOpen(false)} className="modal_store_info" style={{
                direction: i18n.language === "ar" ? "rtl" : "ltr"
            }}>
                <Modal.Header className="order-header" closeButton style={{
                    border: "none",
                    padding: "0",
                    width: "100%"
                }}>
                    <Modal.Title><span className='c-primary'>{t('activation.Nafath')}</span></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className='text-center'>{t('activation.Please select the number through Nafath')}</p>
                    <div className="d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: "42px", width: "120px", height: "120px", borderRadius: "50%", backgroundColor: "#3EB6AE" }} className='d-flex justify-content-center align-items-center'>
                            <strong className='c-white'>{randomNumber}</strong>
                        </span>
                    </div>
                    <p className='text-center mt-3'>{t('activation.The code will regenerate after')} {formatTime(countdown)}</p>
                    <img src={`/media/nafaz${i18n.language === 'ar' ? '_ar' : ''}.svg`} className='w-100' />
                </Modal.Body>
            </Modal>
            <div style={{ marginTop: "260px" }}>
            </div>

            {/* Service Fees Info Modal */}
            {showServiceFeesInfo && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => setShowServiceFeesInfo(false)}
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '24px',
                            maxWidth: '500px',
                            width: '90%',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            position: 'relative'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <h4 style={{ margin: 0, color: '#3EB6AE' }}>{t('store.service_fees')}</h4>
                            <button
                                onClick={() => setShowServiceFeesInfo(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666',
                                    padding: '0',
                                    width: '30px',
                                    height: '30px'
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div style={{ lineHeight: '1.6', color: '#333' }}>
                            {i18n.language === 'ar' ? (
                                <p>
                                    يُطبَّق رسم خدمة بسيط لمرة واحدة عند تنفيذ الطلب، وذلك لدعم استمرارية الخدمة بكفاءة. <strong>لن يُدرج هذا الرسم ضمن الفواتير الشهرية لخطك.</strong>
                                </p>
                            ) : (
                                <p>
                                    A small one-time service fee is applied when placing your order to help maintain efficient service. <strong>This fee will not be included in your monthly line invoices.</strong>
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </>
    );
}

const Slider = (
    props: {
        inners: any[][],
        seperator: any,
    }
) => {
    const [index, setIndex] = React.useState(0);
    const [active, setActive] = React.useState(0);
    const [mobile, setMobile] = React.useState(false);
    const { t, i18n } = useTranslation();
    const handleSelect = (selectedIndex: any, e: any) => {
        setIndex(selectedIndex);
    };

    React.useEffect(() => {
        if (window.innerWidth < 992) {
            setMobile(true);
        }
    }, [])


    return (
        <Animate delay={0.1}>
            {/* <div className=''> */}
            {/* <Animate delay={0.2}>
                        <div className="d-flex my-4 gap-3" style={{maxWidth: "520px", margin: "0 auto"}}>
                        <Button inner={t("esim_.section5.ios")}
                        onClick={
                            () => {
                                setActive(0)
                            }
                        } color={active === 0 ? "primary" : "secondary"}
                        isfullWidth={true} isrounded={true}/>  
                        <Button inner={t("esim_.section5.android")}
                                                    onClick={
                            () => {
                                setActive(1)
                            }
                        } color={active === 1 ? "primary" : "secondary"}
                        isfullWidth={true} isrounded={true}/>
                        </div>
                        </Animate> */}
            <Tabs
                defaultActiveKey="ios"
                id="uncontrolled-tab-example_"
                className="mb-3"

            //   fill
            >
                <Tab eventKey="ios" title={t("esim_.section5.ios")}>

                    {/* <Animate delay={0.3}> */}
                    {/* <Carousel activeIndex={index} onSelect={handleSelect} controls={false} interval={null} indicators={false}> */}
                    <Carousel activeIndex={index} onSelect={handleSelect} interval={null} controls={false} indicators={false}>
                        {props.inners[0].map((inner, index) => {
                            return (

                                <Carousel.Item>
                                    <img src={i18n.language === "en" ? inner.image_en : inner.image_ar}
                                        height={"384px"} style={{ objectFit: "contain" }} className="d-block w-100 my-4" alt="..." />
                                    {/* {inner.image} */}
                                    {/* './media/slider/1.png' */}
                                </Carousel.Item>
                            )
                        })}
                    </Carousel>
                    <strong className='d-block m-auto text-center'>

                        <span>{props.inners[0][index].title}</span>
                        <br />
                        <span style={{ fontWeight: "lighter" }}>{props.inners[0][index].content}</span>
                    </strong>
                </Tab>
                <Tab eventKey="android" title={t("esim_.section5.android")}>
                    <Carousel activeIndex={index} onSelect={handleSelect} interval={null} controls={false} indicators={false}>
                        {props.inners[1].map((inner, index) => {
                            return (

                                <Carousel.Item>
                                    <img src={i18n.language === "en" ? inner.image_en : inner.image_ar}
                                        height={"384px"} style={{ objectFit: "contain" }} className="d-block w-100 my-4" alt="..." />
                                    {/* {inner.image} */}
                                    {/* './media/slider/1.png' */}
                                </Carousel.Item>
                            )
                        })}
                    </Carousel>
                    <strong className='d-block m-auto text-center'>

                        <span>{props.inners[1][index].title}</span>
                        <br />
                        <span style={{ fontWeight: "lighter" }}>{props.inners[1][index].content}</span>
                    </strong>
                </Tab>

                {/* <Tab eventKey="android" title={t("esim_.section5.android")}>
                    <Animate delay={0.3}>
                            <Carousel activeIndex={index} onSelect={handleSelect} controls={false} interval={null} indicators={false}>
                            <Carousel activeIndex={index} onSelect={handleSelect} interval={null} controls={false} indicators={false}>
                                {props.inners[1].map((inner, index) => {
                                    return (
                                        
                                        <Carousel.Item>
                                            <img src={inner.image_mobile} 
                                            height={"384px"} style={{objectFit: "contain"}} className="d-block w-100 my-4" alt="..."/>
                                        </Carousel.Item>
                                    )
                                })}
                            </Carousel>
                        <Animate delay={0.4}>
                       
                        </Animate>                                   
                        </Carousel>
                        </Animate>
                    </Tab> */}
            </Tabs>
            <Animate delay={0.5}>
                <div className='d-flex my-4 justify-content-center justify-content-center'>
                    {Array.from({ length: props.inners[0].length }).map((_, index_) => {
                        return (

                            <div className='me-3' onClick={() => setIndex(index_)} style={{ cursor: "pointer", width: "32px", height: "6px", borderRadius: "3px", backgroundColor: index === index_ ? "#3EB6AE" : "#DADADA" }}></div>
                        )
                    })}
                </div>
            </Animate>

            {/* </div> */}
        </Animate>
    );

}
function TabsInfo({ order }: any) {
    const { t, i18n } = useTranslation();
    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
        setImageError(true);
    };

    const copyToClipboard = (text: string) => {
        if (!text) return;
        navigator.clipboard.writeText(text);
        toast.success(t("global.copied_to_clipboard"));
    };

    // Check if all eSIM fields are null or empty
    const isESimDataMissing = !order?.esim || (
        !order.esim.activation_code &&
        !order.esim.confirmation_code &&
        !order.esim.qrCode_text &&
        !order.esim.qrCode_url &&
        !order.esim.smdp
    );
    return (
        // Install eSim / Access Data
        <>
            {isESimDataMissing ? (
                <div className="alert alert-danger" role="alert">
                    {t("local_sim.errors.eSimDataMissing") || "eSIM data is not available. Please contact support for assistance."}
                </div>
            ) : (
                <Tabs
                    defaultActiveKey={order?.esim?.qrCode_text ? "qr" : "manual"}
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="qr" title={t("store.qr_code" + '')}>
                        <div className="qr_code d-flex flex-column align-items-center justify-content-center gap-5 my-5">
                            <h1>{t("store.scan")}</h1>

                            <QRCodeCanvas value={order.esim.qrCode_text} size={200} />
                            {/* <QRCodeCanvas value={"test"} size={200} /> */}
                            {/*    
            <p><img src="/media/svgs/download_.svg" width={20} /> {t("store.save_as_image")}</p> */}
                        </div>

                    </Tab>
                    <Tab eventKey="manual" title={t("store.manual" + '')}>
                        <div className="row">
                            <div className="col-12 col-xs-12">
                                <div className="input_gray">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex flex-column" style={{ minWidth: 0 }}>
                                            <span>
                                                {t("store.sm")}
                                            </span>
                                            <span className='text-muted' style={{ wordBreak: 'break-all' }}>
                                                {order.esim && order.esim.smdp}
                                            </span>
                                        </div>
                                        <IoCopyOutline size={24} onClick={() => copyToClipboard(order.esim && order.esim.smdp)} style={{ cursor: "pointer", flexShrink: 0, marginLeft: i18n.language === 'ar' ? '0' : '10px', marginRight: i18n.language === 'ar' ? '10px' : '0' }} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-xs-12">
                                <div className="input_gray">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex flex-column" style={{ minWidth: 0 }}>
                                            <span>
                                                {t("store.activation_code")}
                                            </span>
                                            <span className='text-muted' style={{ wordBreak: 'break-all' }}>
                                                {order.esim && order.esim.activation_code}
                                            </span>
                                        </div>
                                        <IoCopyOutline size={24} onClick={() => copyToClipboard(order.esim && order.esim.activation_code)} style={{ cursor: "pointer", flexShrink: 0, marginLeft: i18n.language === 'ar' ? '0' : '10px', marginRight: i18n.language === 'ar' ? '10px' : '0' }} />
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-12 col-xs-12">
                <div className="input_gray">
                <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-column">
                    <span>
                    {t("store.sm")}
                    </span>
                    <span className='text-muted'>
                    {order.esim && order.esim.sM_DP_Address}
                    </span>
                </div>
                <IoCopyOutline size={22} onClick={() => copyToClipboard(order.esim && order.esim.sM_DP_Address)} style={{cursor: "pointer"}} />
                </div>
                </div>
            </div> */}

                            <Slider
                                inners={[[
                                    {
                                        title: t("esim_.section5.element1.item1.title"),
                                        content: t("esim_.section5.element1.item1.sub_title"),
                                        image_en: t("esim_.section5.element1.item1.image"),
                                        image_ar: t("esim_.section5.element1.item1.image")
                                    },
                                    {
                                        title: t("esim_.section5.element1.item2.title"),
                                        content: t("esim_.section5.element1.item2.sub_title"),
                                        image_en: t("esim_.section5.element1.item2.image"),
                                        image_ar: t("esim_.section5.element1.item2.image")
                                    },
                                    {
                                        title: t("esim_.section5.element1.item3.title"),
                                        content: t("esim_.section5.element1.item3.sub_title"),
                                        image_en: t("esim_.section5.element1.item3.image"),
                                        image_ar: t("esim_.section5.element1.item3.image")
                                    },
                                    {
                                        title: t("esim_.section5.element1.item4.title"),
                                        content: t("esim_.section5.element1.item4.sub_title"),
                                        image_en: t("esim_.section5.element1.item4.image"),
                                        image_ar: t("esim_.section5.element1.item4.image")

                                    },
                                    {
                                        title: t("esim_.section5.element1.item5.title"),
                                        content: t("esim_.section5.element1.item5.sub_title"),
                                        image_en: t("esim_.section5.element1.item5.image"),
                                        image_ar: t("esim_.section5.element1.item5.image")
                                    },
                                ], [
                                    {
                                        title: t("esim_.section5.element2.item1.title"),
                                        content: t("esim_.section5.element2.item1.sub_title"),
                                        image_en: t("esim_.section5.element2.item1.image"),
                                        image_ar: t("esim_.section5.element2.item1.image")
                                    },
                                    {
                                        title: t("esim_.section5.element2.item2.title"),
                                        content: t("esim_.section5.element2.item2.sub_title"),
                                        image_en: t("esim_.section5.element2.item2.image"),
                                        image_ar: t("esim_.section5.element2.item2.image")
                                    },
                                    {
                                        title: t("esim_.section5.element2.item3.title"),
                                        content: t("esim_.section5.element2.item3.sub_title"),
                                        image_en: t("esim_.section5.element2.item3.image"),
                                        image_ar: t("esim_.section5.element2.item3.image")

                                    },
                                    {
                                        title: t("esim_.section5.element2.item4.title"),
                                        content: t("esim_.section5.element2.item4.sub_title"),
                                        image_en: t("esim_.section5.element2.item4.image"),
                                        image_ar: t("esim_.section5.element2.item4.image")
                                    },
                                    {
                                        title: t("esim_.section5.element2.item5.title"),
                                        content: t("esim_.section5.element2.item5.sub_title"),
                                        image_en: t("esim_.section5.element2.item5.image"),
                                        image_ar: t("esim_.section5.element2.item5.image")

                                    }
                                ]]}
                                seperator={<div className="slider-seperator">
                                    <div className="slider-seperator__title">
                                        <h1>Choose your plan</h1>
                                    </div>
                                    <div className="slider-seperator__content">
                                        <p>Choose your plan and get your eSIM</p>
                                    </div>
                                </div>
                                }
                            />


                        </div>

                    </Tab>


                </Tabs>
            )}
        </>
    );
}
export default PageLocalSimOrder;
